<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('landingPages.edit.title')"
        )

        // Login form
        landing-page-form
</template>

<script>
    import Layout from '../../Layout/Layout';
    import LandingPageForm from '../Manage/LandingPageForm';
    import Title from '~components/Title';
    import VueTypes from 'vue-types';
    import { mapActions } from 'vuex';

    export default {
        components: {
            Layout,
            LandingPageForm,
            TitleComponent: Title
        },
        props: {
            id: VueTypes.string.def('')
        },
        created() {
            this.read(this.id);
        },
        methods: {
            ...mapActions('landingPages', ['read'])
        }
    };
</script>
